import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import $store from "@/store";
import _ from "@/boot/lodash";
import { EventHint } from "@sentry/browser";

const IgnoredSources = [
  "https://cdn.mouseflow.com/",
  "https://www.googletagmanager.com/gtag/js"
];

function isFromIgnoredSource(exception: EventHint["originalException"]) {
  const matches = `${_.get(exception, "stack")}`.match(
    new RegExp(`at (${IgnoredSources.join("|")})`, "g")
  );
  if (matches && matches.length) return true;
  return false;
}

function isIgnoredRouterError(error: EventHint["originalException"]): boolean {
  if (!_.get(error, "_isRouter")) return false;
  const ignoreList = ["NavigationDuplicated", "NavigationCancelled"];
  if (ignoreList.includes(_.get(error, "name"))) return true;
  return false;
}

export default {
  install: (Vue: any) => {
    const SENTRY_ENV = process.env.VUE_APP_SENTRY_ENV || process.env.NODE_ENV;
    if (["development", "{ENV}", undefined].includes(SENTRY_ENV)) return;

    function getAccessToken(): string {
      const state = _.get($store, "state");
      const context = _.get(state, "context");
      return _.get(state, `auth.${context}.token.access_token`);
    }

    function setUserJti(event) {
      const access_token = getAccessToken();
      if (access_token) {
        const jwt_payload = access_token.split(".")[1];
        const jwt_payload_decoded = JSON.parse(atob(jwt_payload));
        const jti = _.get(jwt_payload_decoded, "jti");
        _.set(event, "user.jti", jti);
      }
    }

    Sentry.init({
      dsn: process.env.VUE_APP_SENTRY_DSN,
      integrations: [new VueIntegration({ Vue, attachProps: true })],
      ignoreErrors: ["ResizeObserver loop limit exceeded"],
      release:
        "upmind@" +
        [(SENTRY_ENV || "").toUpperCase(), process.env.VERSION].join("_"),
      environment: SENTRY_ENV,
      denyUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
      ],
      beforeSend(event, hint) {
        if (isFromIgnoredSource(hint?.originalException)) return null;
        if (isIgnoredRouterError(hint?.originalException)) return null;
        try {
          setUserJti(event);
          $store.dispatch("api/logUncaughtError", {
            level: _.get(event, "level"),
            message: _.get(hint, "originalException.message"),
            exception: _.get(event, "exception"),
            environment: _.get(event, "environment", "").replace(
              "development",
              "local"
            ),
            version: _.get(event, "version"),
            access_token: getAccessToken(),
            extra: {
              event_id: _.get(event, "event_id"),
              contexts: _.get(event, "contexts")
            }
          });
        } catch (err) {
          // Silently catch error
        }
        return event;
      }
    });
  }
};
